const RETURN_BASE = new URL("https://returnto.invalid");
const INVITE_ID = /^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
const INVITE_TOKEN = /^[A-Za-z0-9._~-]+$/;

export function validateAuthReturnPath(value: string | null): string | null {
  if (!value) return null;
  try {
    const parsed = new URL(value, RETURN_BASE);
    if (parsed.origin !== RETURN_BASE.origin || parsed.hash || !/^\/(en|sr)\/staff-invite$/.test(parsed.pathname)) return null;
    const keys = [...parsed.searchParams.keys()];
    const invite = parsed.searchParams.get("invite");
    const token = parsed.searchParams.get("token");
    if (keys.length !== 2 || keys[0] !== "invite" || keys[1] !== "token" || !invite || !INVITE_ID.test(invite) || !token || !INVITE_TOKEN.test(token)) return null;
    return `${parsed.pathname}?invite=${invite}&token=${token}`;
  } catch {
    return null;
  }
}
